<script lang="ts">
    import ReviewsStorefrontValuesBrandingEntity from "@apps/reviews/entities/ReviewsStorefrontValuesBrandingEntity";
    import { setTypedContext } from "@lib/svelte-typed-context";

    import { reviewsThemeContextToken } from "./ReviewsThemeContextToken";

    export let branding: ReviewsStorefrontValuesBrandingEntity;
    export let className: string | undefined = undefined;
    export { className as class };

    const theme = branding.reviewsThemeSettings;
    const icon = branding.reviewsIconSettings;
    const widget = branding.reviewsWidgetsSettings;
    const drawer = branding.reviewsDrawerSettings;

    setTypedContext(reviewsThemeContextToken, branding);
</script>

<div
    class={className}
    style:--gw-rv-theme-primaryColor={theme.primaryColor}
    style:--gw-rv-theme-secondaryColor={theme.secondaryColor}
    style:--gw-rv-icon-starColor={icon.starColor}
    style:--gw-rv-widgets-buttonsColor={theme[widget.buttonsColor]}
    style:--gw-rv-drawer-drawerPosition={drawer.drawerPosition}
    style:--gw-rv-drawer-launcherBackgroundColor={theme[
        drawer.launcherBackgroundColor
    ]}
    style:--gw-rv-drawer-launcherFontColor={drawer.launcherFontColor}
    style:--gw-rv-drawer-launcherIconBackgroundColor={drawer.launcherIconBackgroundColor}
    style:--gw-theme__main-color="var(--gw-rv-widgets-buttonsColor)"
    style:--gw-theme__text-color="var(--gw-rv-theme-secondaryColor)"
    style:--gw-button__main-color="var(--gw-rv-widgets-buttonsColor)"
>
    <slot />
</div>
